import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Archivo+Black&family=Inter:wght@500;600;700;800;900&display=swap";

const STYLE_ID = "sova-landing-styles";

const CSS = `
.sova-root{
  --bg:#FFFFFF;
  --fg:#000000;
  --fg-soft:#1A1A1A;
  --mute:#666666;
  --line:#000000;
  --hair:rgba(0,0,0,0.12);
  --display:'Archivo Black', 'Inter', system-ui, sans-serif;
  --body:'Inter', system-ui, -apple-system, sans-serif;
  font-family:var(--body);
  background:var(--bg);
  color:var(--fg);
  line-height:1.5;
  font-weight:600;
  -webkit-font-smoothing:antialiased;
  min-height:100vh;
}
.sova-root *{margin:0;padding:0;box-sizing:border-box;}
.sova-root ::selection{background:var(--fg);color:var(--bg);}
.sova-root a{color:inherit;text-decoration:none;}
.sova-root button{font-family:inherit;}

.sova-root .wrap{max-width:1180px;margin:0 auto;padding:0 32px;}
.sova-root .eyebrow{font-family:var(--body);font-size:11px;letter-spacing:0.28em;text-transform:uppercase;font-weight:800;}

/* HERO */
.sova-root .hero{background:var(--bg);color:var(--fg);position:relative;padding:34px 0 96px;border-bottom:2px solid var(--line);}
.sova-root nav{display:flex;justify-content:space-between;align-items:center;padding-bottom:64px;border-bottom:1px solid var(--hair);margin-bottom:88px;}
.sova-root .logo{font-family:var(--display);font-size:30px;line-height:1;letter-spacing:-0.02em;color:var(--fg);text-transform:uppercase;}
.sova-root .logo-img{display:inline-block;text-decoration:none;line-height:0;}
.sova-root .logo-img img{display:block;height:clamp(110px, 19vw, 256px);width:auto;}
.sova-root .logo-img:hover{background:#111;border-color:#111;}
.sova-root nav .eyebrow{color:var(--fg);}

.sova-root .hero-inner{position:relative;max-width:1000px;}
.sova-root .badge{display:inline-flex;align-items:center;gap:10px;border:2px solid var(--fg);
  padding:8px 16px;font-size:12px;letter-spacing:0.06em;color:var(--fg);background:var(--bg);
  text-transform:uppercase;font-weight:800;margin-bottom:36px;}
.sova-root .badge .dot{width:10px;height:10px;background:var(--fg);}

.sova-root h1{font-family:var(--display);font-size:clamp(56px,9.5vw,128px);line-height:0.92;
  letter-spacing:-0.04em;margin-bottom:32px;text-transform:uppercase;}
.sova-root h1 em{font-style:normal;background:var(--fg);color:var(--bg);padding:0 0.08em;display:inline-block;}
.sova-root .sub{font-size:clamp(18px,2vw,22px);color:var(--fg-soft);max-width:680px;font-weight:600;margin-bottom:44px;line-height:1.45;}

.sova-root .cta-row{display:flex;gap:14px;flex-wrap:wrap;align-items:center;}
.sova-root .btn{display:inline-flex;align-items:center;gap:9px;font-family:var(--body);font-weight:800;
  font-size:15px;padding:18px 28px;cursor:pointer;text-decoration:none;text-transform:uppercase;
  letter-spacing:0.04em;border:2px solid var(--fg);transition:transform .15s ease, background .15s ease, color .15s ease;}
.sova-root .btn-primary{background:var(--fg);color:var(--bg);}
.sova-root .btn-primary:hover{background:var(--bg);color:var(--fg);transform:translate(-3px,-3px);box-shadow:6px 6px 0 var(--fg);}
.sova-root .btn-ghost{background:var(--bg);color:var(--fg);}
.sova-root .btn-ghost:hover{background:var(--fg);color:var(--bg);transform:translate(-3px,-3px);box-shadow:6px 6px 0 var(--fg);}
.sova-root .seats{font-size:13px;color:var(--fg);margin-left:8px;font-weight:700;text-transform:uppercase;letter-spacing:0.04em;}

.sova-root .reveal{opacity:0;transform:translateY(20px);animation:sova-rise .8s cubic-bezier(.2,.7,.2,1) forwards;}
.sova-root .d1{animation-delay:.05s}
.sova-root .d2{animation-delay:.16s}
.sova-root .d3{animation-delay:.27s}
.sova-root .d4{animation-delay:.38s}
.sova-root .d5{animation-delay:.49s}
@keyframes sova-rise{to{opacity:1;transform:none;}}

/* MARQUEE */
.sova-root .strip{background:var(--fg);color:var(--bg);padding:22px 0;border-top:2px solid var(--fg);border-bottom:2px solid var(--fg);overflow:hidden;white-space:nowrap;}
.sova-root .strip-track{display:inline-flex;gap:42px;animation:sova-slide 32s linear infinite;}
.sova-root .strip-track span{font-family:var(--display);font-size:18px;color:var(--bg);text-transform:uppercase;letter-spacing:0.02em;}
.sova-root .strip-track span::after{content:"●";margin-left:42px;color:var(--bg);font-size:8px;vertical-align:middle;}
@keyframes sova-slide{from{transform:translateX(0)}to{transform:translateX(-50%)}}

/* SECTIONS */
.sova-root section{padding:108px 0;border-bottom:2px solid var(--fg);}
.sova-root .sec-head{max-width:780px;margin-bottom:64px;}
.sova-root .sec-head .eyebrow{margin-bottom:20px;display:block;}
.sova-root h2{font-family:var(--display);font-size:clamp(36px,5.2vw,68px);line-height:0.94;letter-spacing:-0.025em;text-transform:uppercase;}
.sova-root h2 em{font-style:normal;background:var(--fg);color:var(--bg);padding:0 0.1em;display:inline-block;}
.sova-root .lead{font-size:18px;color:var(--fg-soft);margin-top:22px;font-weight:600;line-height:1.5;}

.sova-root .problem{background:var(--bg);}
.sova-root .pgrid{display:grid;grid-template-columns:repeat(3,1fr);gap:0;border:2px solid var(--fg);}
.sova-root .pcard{background:var(--bg);padding:36px 32px;border-right:2px solid var(--fg);}
.sova-root .pcard:last-child{border-right:none;}
.sova-root .pcard h3{font-family:var(--display);font-size:22px;margin-bottom:14px;text-transform:uppercase;letter-spacing:-0.01em;line-height:1.05;}
.sova-root .pcard p{font-size:15.5px;color:var(--fg-soft);font-weight:500;line-height:1.55;}
.sova-root .pnum{font-family:var(--display);font-size:42px;color:var(--fg);margin-bottom:18px;line-height:0.9;}

.sova-root .roster{display:grid;grid-template-columns:repeat(4,1fr);gap:0;margin-top:8px;border:2px solid var(--fg);}
.sova-root .seat{padding:28px 24px;border-right:2px solid var(--fg);border-bottom:2px solid var(--fg);background:var(--bg);transition:background .15s ease, color .15s ease;}
.sova-root .seat:nth-child(4n){border-right:none;}
.sova-root .seat:nth-last-child(-n+4){border-bottom:none;}
.sova-root .seat:hover{background:var(--fg);color:var(--bg);}
.sova-root .seat .role{font-family:var(--display);font-size:21px;margin-bottom:6px;text-transform:uppercase;letter-spacing:-0.01em;line-height:1.05;}
.sova-root .seat .who{font-size:11px;letter-spacing:0.18em;text-transform:uppercase;color:var(--fg);font-weight:800;margin-bottom:10px;}
.sova-root .seat:hover .who{color:var(--bg);}
.sova-root .board-note{margin-top:48px;border-left:6px solid var(--fg);padding:8px 0 8px 26px;font-family:var(--display);
  font-size:24px;line-height:1.25;max-width:780px;text-transform:uppercase;letter-spacing:-0.015em;}
.sova-root .board-note em{font-style:normal;background:var(--fg);color:var(--bg);padding:0 0.1em;display:inline-block;}

/* WHY-IT-MATTERS — softer, calm */
.sova-root .calm{background:var(--bg);}
.sova-root .calm .sec-head{max-width:840px;margin-bottom:42px;}
.sova-root .calm h2{font-size:clamp(32px,4.6vw,56px);letter-spacing:-0.025em;}
.sova-root .calm .reasons{display:grid;grid-template-columns:1fr;gap:0;max-width:780px;border-top:1px solid rgba(0,0,0,0.18);}
.sova-root .calm .reasons li{display:flex;gap:24px;align-items:baseline;padding:22px 0;border-bottom:1px solid rgba(0,0,0,0.18);font-size:18px;font-weight:600;list-style:none;color:var(--fg);}
.sova-root .calm .reasons li .ix{font-family:var(--display);font-size:17px;color:var(--fg);min-width:36px;letter-spacing:-0.02em;}

/* PHASE DIAGRAM */
.sova-root .phase{background:var(--bg);}
.sova-root .phase-flow{display:grid;grid-template-columns:repeat(7,1fr);gap:0;border:1px solid rgba(0,0,0,0.18);background:#FAFAF8;}
.sova-root .phase-step{padding:24px 18px;border-right:1px solid rgba(0,0,0,0.18);text-align:left;position:relative;background:#FAFAF8;}
.sova-root .phase-step:last-child{border-right:none;background:var(--fg);color:var(--bg);}
.sova-root .phase-step .pix{font-family:var(--display);font-size:11px;letter-spacing:0.18em;text-transform:uppercase;color:var(--fg);margin-bottom:14px;}
.sova-root .phase-step:last-child .pix{color:var(--bg);}
.sova-root .phase-step .ptitle{font-family:var(--display);font-size:20px;line-height:1.05;text-transform:uppercase;letter-spacing:-0.01em;margin-bottom:8px;}
.sova-root .phase-step .psub{font-size:12.5px;color:rgba(0,0,0,0.65);font-weight:500;line-height:1.45;}
.sova-root .phase-step:last-child .psub{color:rgba(255,255,255,0.78);}
.sova-root .phase-foot{margin-top:24px;font-size:15px;font-weight:600;color:rgba(0,0,0,0.7);max-width:680px;line-height:1.55;}

/* DIVISION OF LABOR — black background */
.sova-root .division{background:var(--fg);color:var(--bg);border-bottom:2px solid var(--fg);}
.sova-root .division .sec-head .eyebrow{color:var(--bg);}
.sova-root .division h2{color:var(--bg);}
.sova-root .division h2 em{background:var(--bg);color:var(--fg);}
.sova-root .division .lead{color:rgba(255,255,255,0.78);}
.sova-root .division-grid{display:grid;grid-template-columns:1fr 1fr;gap:0;border:1px solid var(--bg);}
.sova-root .division-col{padding:36px 36px 28px;}
.sova-root .division-col:first-child{border-right:1px solid var(--bg);}
.sova-root .division-col .colhead{font-family:var(--display);font-size:11px;letter-spacing:0.2em;text-transform:uppercase;color:var(--bg);margin-bottom:24px;opacity:0.7;}
.sova-root .division-col .colbig{font-family:var(--display);font-size:32px;line-height:0.95;letter-spacing:-0.02em;text-transform:uppercase;margin-bottom:24px;}
.sova-root .division-col ul{list-style:none;display:grid;gap:14px;}
.sova-root .division-col li{display:flex;gap:14px;align-items:flex-start;font-size:15px;font-weight:600;line-height:1.5;color:var(--bg);}
.sova-root .division-col li::before{content:"";flex-shrink:0;width:14px;height:14px;margin-top:4px;background:var(--bg);}
.sova-root .division-foot{margin-top:30px;font-size:14px;font-weight:600;color:rgba(255,255,255,0.7);max-width:600px;line-height:1.55;}

/* PRICING — 3 tiers + executive bench strip */
.sova-root .pricing-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:0;border:2px solid var(--fg);background:var(--bg);margin-top:8px;}
.sova-root .ptier{padding:36px 32px;border-right:2px solid var(--fg);display:flex;flex-direction:column;}
.sova-root .ptier:last-child{border-right:none;}
.sova-root .ptier.popular{background:var(--fg);color:var(--bg);}
.sova-root .ptier .ptag{font-family:var(--display);font-size:11px;letter-spacing:0.22em;text-transform:uppercase;margin-bottom:18px;display:inline-block;}
.sova-root .ptier .pname{font-family:var(--display);font-size:30px;line-height:0.95;letter-spacing:-0.02em;text-transform:uppercase;margin-bottom:8px;}
.sova-root .ptier .ptag-line{font-size:13px;color:rgba(0,0,0,0.65);font-weight:600;margin-bottom:22px;line-height:1.4;min-height:36px;}
.sova-root .ptier.popular .ptag-line{color:rgba(255,255,255,0.78);}
.sova-root .ptier .pprice{display:flex;align-items:baseline;gap:10px;margin-bottom:8px;}
.sova-root .ptier .pprice .now{font-family:var(--display);font-size:54px;line-height:0.9;letter-spacing:-0.04em;}
.sova-root .ptier .pprice .per{font-size:13px;font-weight:800;letter-spacing:0.06em;text-transform:uppercase;color:rgba(0,0,0,0.7);}
.sova-root .ptier.popular .pprice .per{color:rgba(255,255,255,0.78);}
.sova-root .ptier .pprice .was{font-size:14px;color:rgba(0,0,0,0.45);text-decoration:line-through;font-weight:700;}
.sova-root .ptier.popular .pprice .was{color:rgba(255,255,255,0.4);}
.sova-root .ptier .plock{font-size:11px;font-weight:800;letter-spacing:0.1em;text-transform:uppercase;border-left:4px solid var(--fg);padding-left:10px;margin-bottom:24px;}
.sova-root .ptier.popular .plock{border-left-color:var(--bg);}
.sova-root .ptier ul{list-style:none;display:grid;gap:11px;margin-bottom:28px;flex:1;}
.sova-root .ptier li{display:flex;gap:11px;align-items:flex-start;font-size:14px;font-weight:600;line-height:1.45;}
.sova-root .ptier li::before{content:"";flex-shrink:0;width:13px;height:13px;background:var(--fg);margin-top:3px;}
.sova-root .ptier.popular li::before{background:var(--bg);}
.sova-root .ptier .pbtn{display:inline-flex;align-items:center;justify-content:center;gap:8px;font-family:var(--body);font-weight:800;font-size:13px;padding:14px 18px;cursor:pointer;text-transform:uppercase;letter-spacing:0.06em;border:2px solid var(--fg);transition:transform .15s ease, background .15s ease, color .15s ease, box-shadow .15s ease;text-decoration:none;}
.sova-root .ptier .pbtn-solid{background:var(--fg);color:var(--bg);}
.sova-root .ptier.popular .pbtn-solid{background:var(--bg);color:var(--fg);border-color:var(--bg);}
.sova-root .ptier .pbtn-ghost{background:var(--bg);color:var(--fg);}
.sova-root .ptier.popular .pbtn-ghost{background:var(--fg);color:var(--bg);border-color:var(--bg);}
.sova-root .ptier .pbtn:hover{transform:translate(-3px,-3px);box-shadow:6px 6px 0 var(--fg);}
.sova-root .ptier.popular .pbtn:hover{box-shadow:6px 6px 0 var(--bg);}

/* Executive bench strip — below pricing */
.sova-root .exec-strip{margin-top:32px;border:2px solid var(--fg);background:var(--bg);padding:34px 36px;display:grid;grid-template-columns:1.4fr 1fr;gap:32px;align-items:center;}
.sova-root .exec-strip .estag{font-family:var(--display);font-size:11px;letter-spacing:0.22em;text-transform:uppercase;margin-bottom:10px;}
.sova-root .exec-strip h3{font-family:var(--display);font-size:30px;line-height:0.95;letter-spacing:-0.02em;text-transform:uppercase;margin-bottom:10px;}
.sova-root .exec-strip h3 em{font-style:normal;background:var(--fg);color:var(--bg);padding:0 0.1em;display:inline-block;}
.sova-root .exec-strip p{font-size:14.5px;color:rgba(0,0,0,0.7);font-weight:600;line-height:1.55;}
.sova-root .pricing-foot{margin-top:28px;font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:rgba(0,0,0,0.65);text-align:center;}

/* WHY FOUNDERS CHOOSE — stats */
.sova-root .why-choose{background:var(--bg);}
.sova-root .stats-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:0;border:2px solid var(--fg);}
.sova-root .stat{padding:38px 32px;border-right:2px solid var(--fg);background:var(--bg);}
.sova-root .stat:last-child{border-right:none;}
.sova-root .stat .sicon{width:42px;height:42px;background:var(--fg);margin-bottom:22px;}
.sova-root .stat .snum{font-family:var(--display);font-size:54px;line-height:0.9;letter-spacing:-0.03em;margin-bottom:6px;}
.sova-root .stat .ssub{font-size:11px;font-weight:800;letter-spacing:0.16em;text-transform:uppercase;color:rgba(0,0,0,0.6);margin-bottom:22px;padding-bottom:18px;border-bottom:1px solid rgba(0,0,0,0.18);}
.sova-root .stat .stitle{font-family:var(--display);font-size:22px;line-height:1.05;letter-spacing:-0.01em;text-transform:uppercase;margin-bottom:10px;}
.sova-root .stat .sdesc{font-size:14px;color:rgba(0,0,0,0.7);font-weight:600;line-height:1.5;}

/* FEEDBACK FORM */
.sova-root .feedback{background:var(--fg);color:var(--bg);border-bottom:2px solid var(--fg);}
.sova-root .feedback .sec-head .eyebrow{color:var(--bg);}
.sova-root .feedback h2{color:var(--bg);}
.sova-root .feedback h2 em{background:var(--bg);color:var(--fg);}
.sova-root .feedback .lead{color:rgba(255,255,255,0.78);}
.sova-root .feedback-grid{display:grid;grid-template-columns:1.2fr 1fr;gap:0;border:2px solid var(--bg);background:var(--fg);}
.sova-root .feedback-form{padding:36px;border-right:2px solid var(--bg);}
.sova-root .feedback-side{padding:36px;background:var(--bg);color:var(--fg);}
.sova-root .feedback-row{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:14px;}
.sova-root .feedback label{display:block;font-size:10px;font-weight:800;letter-spacing:0.2em;text-transform:uppercase;margin-bottom:8px;color:rgba(255,255,255,0.7);}
.sova-root .feedback input,.sova-root .feedback textarea{
  width:100%;background:var(--fg);color:var(--bg);border:2px solid var(--bg);
  padding:14px 16px;font-family:var(--body);font-size:15px;font-weight:600;
  outline:none;border-radius:0;
}
.sova-root .feedback input:focus,.sova-root .feedback textarea:focus{
  background:var(--bg);color:var(--fg);
}
.sova-root .feedback input::placeholder,.sova-root .feedback textarea::placeholder{color:rgba(255,255,255,0.45);}
.sova-root .feedback input:focus::placeholder,.sova-root .feedback textarea:focus::placeholder{color:rgba(0,0,0,0.4);}
.sova-root .feedback textarea{resize:vertical;min-height:150px;font-family:var(--body);line-height:1.5;}
.sova-root .feedback-submit{margin-top:6px;background:var(--bg);color:var(--fg);border:2px solid var(--bg);padding:16px 22px;
  font-family:var(--body);font-weight:800;font-size:14px;letter-spacing:0.06em;text-transform:uppercase;
  cursor:pointer;transition:transform .15s ease, box-shadow .15s ease;width:100%;display:inline-flex;align-items:center;justify-content:center;gap:8px;}
.sova-root .feedback-submit:hover:not(:disabled){transform:translate(-3px,-3px);box-shadow:6px 6px 0 var(--bg);}
.sova-root .feedback-submit:disabled{opacity:0.55;cursor:not-allowed;}
.sova-root .feedback-status{margin-top:14px;font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;}
.sova-root .feedback-status.ok{color:var(--bg);}
.sova-root .feedback-status.err{color:#FFC9C9;}
.sova-root .feedback-side .ssbig{font-family:var(--display);font-size:34px;line-height:0.95;letter-spacing:-0.02em;text-transform:uppercase;margin-bottom:14px;}
.sova-root .feedback-side .ssbig em{font-style:normal;background:var(--fg);color:var(--bg);padding:0 0.1em;display:inline-block;}
.sova-root .feedback-side p{font-size:14.5px;color:rgba(0,0,0,0.75);font-weight:600;line-height:1.55;margin-bottom:18px;}
.sova-root .feedback-side .mailto-btn{display:inline-flex;align-items:center;gap:8px;font-family:var(--body);font-weight:800;font-size:13px;
  padding:14px 18px;border:2px solid var(--fg);background:var(--fg);color:var(--bg);text-decoration:none;
  text-transform:uppercase;letter-spacing:0.06em;transition:transform .15s ease, box-shadow .15s ease;}
.sova-root .feedback-side .mailto-btn:hover{transform:translate(-3px,-3px);box-shadow:6px 6px 0 var(--fg);}
.sova-root .feedback-side .addr{margin-top:24px;padding-top:18px;border-top:1px solid rgba(0,0,0,0.18);font-size:11px;font-weight:800;letter-spacing:0.12em;text-transform:uppercase;color:rgba(0,0,0,0.6);}
.sova-root .feedback-side .addr a{color:var(--fg);text-decoration:underline;text-underline-offset:3px;}

/* APPROVED BENCH GRID */
.sova-root .bench-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:0;border:2px solid var(--fg);margin-top:32px;background:var(--bg);}
.sova-root .bench-card{padding:30px 28px;border-right:2px solid var(--fg);border-bottom:2px solid var(--fg);display:flex;flex-direction:column;background:var(--bg);}
.sova-root .bench-card:nth-child(3n){border-right:none;}
.sova-root .bench-card:nth-last-child(-n+3){border-bottom:none;}
.sova-root .bench-name{font-family:var(--display);font-size:22px;line-height:1.05;text-transform:uppercase;letter-spacing:-0.015em;margin-bottom:4px;}
.sova-root .bench-role{font-size:11px;font-weight:800;letter-spacing:0.14em;text-transform:uppercase;color:rgba(0,0,0,0.7);margin-bottom:18px;padding-bottom:14px;border-bottom:1px solid rgba(0,0,0,0.18);}
.sova-root .bench-bio{font-size:14px;font-weight:600;color:var(--fg);line-height:1.5;margin-bottom:14px;flex:1;}
.sova-root .bench-tags{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:14px;}
.sova-root .bench-tag{font-size:10px;font-weight:800;letter-spacing:0.1em;text-transform:uppercase;border:1.5px solid var(--fg);padding:4px 10px;}
.sova-root .bench-meta{font-size:11px;font-weight:800;letter-spacing:0.14em;text-transform:uppercase;color:var(--fg);margin-bottom:14px;border-left:4px solid var(--fg);padding-left:10px;}
.sova-root .bench-cta{display:inline-flex;align-items:center;justify-content:center;gap:8px;font-family:var(--body);font-weight:800;font-size:12px;
  padding:13px 16px;border:2px solid var(--fg);background:var(--fg);color:var(--bg);text-decoration:none;
  text-transform:uppercase;letter-spacing:0.06em;transition:transform .15s ease, box-shadow .15s ease;text-align:center;}
.sova-root .bench-cta:hover{transform:translate(-3px,-3px);box-shadow:6px 6px 0 var(--fg);}

/* Recast cabinet seats with verb-led one-liner */
.sova-root .seat .verb{font-size:13px;color:rgba(0,0,0,0.7);font-weight:600;line-height:1.45;margin-top:12px;padding-top:12px;border-top:1px solid rgba(0,0,0,0.18);}
.sova-root .seat:hover .verb{color:rgba(255,255,255,0.78);border-top-color:rgba(255,255,255,0.18);}

.sova-root .steps{background:var(--fg);color:var(--bg);border-bottom:2px solid var(--fg);}
.sova-root .steps .sec-head .eyebrow{color:var(--bg);}
.sova-root .steps h2{color:var(--bg);}
.sova-root .steps h2 em{background:var(--bg);color:var(--fg);}
.sova-root .steps .lead{color:rgba(255,255,255,0.78);}
.sova-root .stepgrid{display:grid;grid-template-columns:repeat(3,1fr);gap:0;border:2px solid var(--bg);}
.sova-root .step{padding:36px 32px;border-right:2px solid var(--bg);}
.sova-root .step:last-child{border-right:none;}
.sova-root .step .n{font-family:var(--display);font-size:64px;color:var(--bg);line-height:0.9;margin-bottom:18px;letter-spacing:-0.04em;}
.sova-root .step h3{font-family:var(--display);font-size:24px;margin:0 0 12px;text-transform:uppercase;color:var(--bg);letter-spacing:-0.01em;}
.sova-root .step p{font-size:15.5px;color:rgba(255,255,255,0.78);font-weight:500;line-height:1.55;}

.sova-root .offer{background:var(--bg);}
.sova-root .offer-card{background:var(--bg);color:var(--fg);border:2px solid var(--fg);padding:60px;position:relative;}
.sova-root .offer-grid{display:grid;grid-template-columns:1.1fr 1fr;gap:60px;position:relative;align-items:center;}
.sova-root .offer-card .eyebrow{margin-bottom:20px;display:block;}
.sova-root .offer-card h2{margin-bottom:22px;}
.sova-root .price{display:flex;align-items:baseline;gap:14px;margin:14px 0 10px;}
.sova-root .price .now{font-family:var(--display);font-size:88px;line-height:0.9;letter-spacing:-0.04em;}
.sova-root .price .per{font-size:16px;color:var(--fg);font-weight:700;text-transform:uppercase;letter-spacing:0.06em;}
.sova-root .price .was{font-size:18px;color:var(--mute);text-decoration:line-through;font-weight:700;}
.sova-root .lock{font-size:13px;color:var(--fg);margin-bottom:32px;font-weight:800;text-transform:uppercase;letter-spacing:0.08em;border-left:4px solid var(--fg);padding-left:12px;}
.sova-root .incl{list-style:none;display:grid;gap:14px;}
.sova-root .incl li{display:flex;gap:14px;align-items:flex-start;font-size:15.5px;color:var(--fg);font-weight:600;line-height:1.5;}
.sova-root .incl li::before{content:"";flex-shrink:0;width:18px;height:18px;margin-top:2px;background:var(--fg);}
.sova-root .reserve{margin-top:0;}
.sova-root .reserve .btn-primary{width:100%;justify-content:center;font-size:15.5px;padding:20px;}
.sova-root .reserve .fine{font-size:12.5px;color:var(--mute);text-align:center;margin-top:16px;font-weight:600;text-transform:uppercase;letter-spacing:0.05em;}
.sova-root .reserve-intro{font-size:15.5px;color:var(--fg-soft);margin-bottom:26px;font-weight:600;line-height:1.55;}

.sova-root .founder{background:var(--bg);}
.sova-root .founder-inner{max-width:880px;}
.sova-root .founder blockquote{font-family:var(--display);font-size:clamp(26px,3.4vw,38px);line-height:1.15;letter-spacing:-0.02em;text-transform:uppercase;}
.sova-root .founder blockquote em{font-style:normal;background:var(--fg);color:var(--bg);padding:0 0.1em;display:inline-block;}
.sova-root .founder-eyebrow{display:block;margin-bottom:28px;}
.sova-root .sig{margin-top:32px;font-size:14px;color:var(--fg);font-weight:600;text-transform:uppercase;letter-spacing:0.08em;}
.sova-root .sig strong{font-weight:900;color:var(--fg);}

.sova-root .faq details{border-top:2px solid var(--fg);padding:26px 0;}
.sova-root .faq details:last-child{border-bottom:2px solid var(--fg);}
.sova-root .faq summary{font-family:var(--display);font-size:22px;cursor:pointer;list-style:none;display:flex;justify-content:space-between;align-items:center;gap:24px;text-transform:uppercase;letter-spacing:-0.01em;line-height:1.15;}
.sova-root .faq summary::-webkit-details-marker{display:none;}
.sova-root .faq summary::after{content:"+";font-size:32px;color:var(--fg);font-family:var(--display);transition:transform .2s ease;line-height:1;}
.sova-root .faq details[open] summary::after{transform:rotate(45deg);}
.sova-root .faq p{font-size:16px;color:var(--fg-soft);margin-top:16px;max-width:820px;font-weight:500;line-height:1.55;}

.sova-root .final{background:var(--fg);color:var(--bg);text-align:center;border-bottom:none;}
.sova-root .final h2{color:var(--bg);margin-bottom:28px;}
.sova-root .final h2 em{background:var(--bg);color:var(--fg);}
.sova-root .final .sub{margin:0 auto 38px;color:rgba(255,255,255,0.78);}
.sova-root .final .cta-row{justify-content:center;}
.sova-root .final .btn-primary{background:var(--bg);color:var(--fg);border-color:var(--bg);}
.sova-root .final .btn-primary:hover{background:var(--fg);color:var(--bg);box-shadow:6px 6px 0 var(--bg);}

.sova-root footer{background:var(--bg);color:var(--fg);padding:44px 0 56px;border-top:2px solid var(--fg);}
.sova-root .foot-inner{display:flex;justify-content:space-between;flex-wrap:wrap;gap:16px;font-size:13px;align-items:flex-start;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;}
.sova-root .foot-inner .logo{font-size:22px;text-transform:uppercase;letter-spacing:-0.02em;}
.sova-root .disclaimer{font-size:11.5px;color:var(--mute);max-width:760px;margin-top:22px;line-height:1.55;font-weight:500;text-transform:none;letter-spacing:0;}

@media(max-width:960px){
  .sova-root .pgrid,.sova-root .stepgrid{grid-template-columns:1fr 1fr;}
  .sova-root .roster{grid-template-columns:1fr 1fr;}
  .sova-root .pcard,.sova-root .step{border-right:none;border-bottom:2px solid var(--fg);}
  .sova-root .stepgrid .step:last-child{border-bottom:none;}
  .sova-root .seat{border-right:2px solid var(--fg);border-bottom:2px solid var(--fg);}
  .sova-root .seat:nth-child(4n){border-right:2px solid var(--fg);}
  .sova-root .seat:nth-child(2n){border-right:none;}
  .sova-root .seat:nth-last-child(-n+4){border-bottom:2px solid var(--fg);}
  .sova-root .seat:nth-last-child(-n+2){border-bottom:none;}
  .sova-root .offer-grid{grid-template-columns:1fr;gap:40px;}
  .sova-root .offer-card{padding:40px 28px;}
  .sova-root .phase-flow{grid-template-columns:repeat(2,1fr);}
  .sova-root .phase-step{border-right:1px solid rgba(0,0,0,0.18);border-bottom:1px solid rgba(0,0,0,0.18);}
  .sova-root .phase-step:nth-child(2n){border-right:none;}
  .sova-root .division-grid{grid-template-columns:1fr;}
  .sova-root .division-col:first-child{border-right:none;border-bottom:1px solid var(--bg);}
  .sova-root .pricing-grid,.sova-root .stats-grid{grid-template-columns:1fr;}
  .sova-root .ptier,.sova-root .stat{border-right:none;border-bottom:2px solid var(--fg);}
  .sova-root .ptier:last-child,.sova-root .stat:last-child{border-bottom:none;}
  .sova-root .exec-strip{grid-template-columns:1fr;padding:28px 24px;}
  .sova-root .feedback-grid{grid-template-columns:1fr;}
  .sova-root .feedback-form{border-right:none;border-bottom:2px solid var(--bg);padding:28px;}
  .sova-root .feedback-side{padding:28px;}
  .sova-root .feedback-row{grid-template-columns:1fr;}
  .sova-root .bench-grid{grid-template-columns:1fr;}
  .sova-root .bench-card{border-right:none;border-bottom:2px solid var(--fg);}
  .sova-root .bench-card:last-child{border-bottom:none;}
}
@media(max-width:560px){
  .sova-root nav{padding-bottom:40px;margin-bottom:56px;}
  .sova-root .pgrid,.sova-root .stepgrid,.sova-root .roster{grid-template-columns:1fr;}
  .sova-root .pcard,.sova-root .step,.sova-root .seat{border-right:none !important;border-bottom:2px solid var(--fg) !important;}
  .sova-root .pcard:last-child,.sova-root .step:last-child,.sova-root .seat:last-child{border-bottom:none !important;}
  .sova-root section{padding:72px 0;}
  .sova-root .hero{padding-bottom:72px;}
  .sova-root h1{font-size:clamp(40px,12vw,72px);}
  .sova-root .price .now{font-size:64px;}
}
`;

function ensureFonts() {
  if (typeof document === "undefined") return;
  if (document.querySelector('link[data-sova-fonts="1"]')) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = FONTS_HREF;
  link.setAttribute("data-sova-fonts", "1");
  document.head.appendChild(link);
}

function ensureStyles() {
  if (typeof document === "undefined") return;
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  // CSS is a hard-coded module constant — no user input, no XSS surface.
  // We inject it once into <head> rather than rendering inline so React
  // doesn't have to remount it and so we avoid dangerouslySetInnerHTML.
  style.appendChild(document.createTextNode(CSS));
  document.head.appendChild(style);
}

export default function SovaLanding() {
  const [fbName, setFbName] = useState("");
  const [fbEmail, setFbEmail] = useState("");
  const [fbMsg, setFbMsg] = useState("");
  const [fbBusy, setFbBusy] = useState(false);
  const [fbStatus, setFbStatus] = useState(null); // {kind:'ok'|'err', text}
  const [experts, setExperts] = useState([]);
  const [bookingBusy, setBookingBusy] = useState(""); // expert id mid-checkout

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/bench`);
        if (alive) setExperts(data.experts || []);
      } catch (e) {
        // Silent fail — bench grid just won't render
        console.warn("bench fetch failed", e);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    ensureFonts();
    ensureStyles();
    const prevTitle = document.title;
    document.title = "HEY SOVA — Your AI Executive";
    return () => {
      document.title = prevTitle;
    };
  }, []);

  const goToApp = () => {
    window.location.href = "/app";
  };

  async function startBenchBooking(expert) {
    if (bookingBusy) return;
    const name = window.prompt(`Your name to share with ${expert.name}?`, "")?.trim();
    if (!name) return;
    const email = window.prompt("Your email (so we can send the receipt + calendar link)?", "")?.trim();
    if (!email || !email.includes("@")) {
      window.alert("A valid email is required to book.");
      return;
    }
    setBookingBusy(expert.id);
    try {
      const { data } = await axios.post(`${API}/bench/${expert.id}/checkout`, {
        expert_id: expert.id,
        user_name: name,
        user_email: email,
        origin_url: window.location.origin,
      });
      window.location.href = data.url;
    } catch (e) {
      window.alert(e?.response?.data?.detail || "Couldn't start checkout. Try again.");
      setBookingBusy("");
    }
  }

  async function submitFeedback(e) {
    e.preventDefault();
    if (fbBusy) return;
    const msg = fbMsg.trim();
    if (!msg) {
      setFbStatus({ kind: "err", text: "Please write a message before sending." });
      return;
    }
    setFbBusy(true);
    setFbStatus(null);
    try {
      await axios.post(`${API}/feedback`, {
        name: fbName.trim(),
        email: fbEmail.trim(),
        message: msg,
      });
      setFbStatus({ kind: "ok", text: "Thank you — we read every note." });
      setFbName("");
      setFbEmail("");
      setFbMsg("");
    } catch (err) {
      const detail =
        err?.response?.data?.detail ||
        "Couldn't send right now — try again, or email us at info@heysova.io.";
      setFbStatus({ kind: "err", text: detail });
    } finally {
      setFbBusy(false);
    }
  }

  return (
    <div className="sova-root" data-testid="sova-landing">
      <header className="hero">
        <div className="wrap">
          <nav className="reveal d1">
            <a href="/" className="logo logo-img" aria-label="Hey Sova home" data-testid="sova-logo">
              <img src="/heysova-logo.png?v=6" alt="HEY SOVA" />
            </a>
            <span className="eyebrow">For founders & entrepreneurs</span>
          </nav>
          <div className="hero-inner">
            <div className="badge reveal d2" data-testid="hero-badge">
              <span className="dot" /> Founding 50 — limited seats open now
            </div>
            <h1 className="reveal d3">
              The A.I. executive team
              <br />
              <em>available 24/7</em>
              <br />
              + a real executive team on request.
            </h1>
            <p className="sub reveal d4">
              Your AI executive team — 24/7 on call. A CFO, a CMO, a strategist, a head of growth
              and more — each briefed on your company, ready the moment you need a sharp second
              opinion. Plus a boardroom where the whole team weighs in on one decision at once.
            </p>
            <div className="cta-row reveal d5">
              <button
                type="button"
                onClick={goToApp}
                className="btn btn-primary"
                data-testid="hero-reserve-btn"
              >
                Reserve your seat →
              </button>
              <a href="#how" className="btn btn-ghost" data-testid="hero-how-btn">
                See how it works
              </a>
              <span className="seats">$80/month · cancel anytime</span>
            </div>
          </div>
        </div>
      </header>

      <div className="strip">
        <div className="strip-track">
          <span>Chief Strategist</span>
          <span>CFO</span>
          <span>CMO</span>
          <span>Head of Growth</span>
          <span>Chief of Staff</span>
          <span>Investor Relations</span>
          <span>Head of Product</span>
          <span>Legal &amp; Risk</span>
          <span>Chief Strategist</span>
          <span>CFO</span>
          <span>CMO</span>
          <span>Head of Growth</span>
          <span>Chief of Staff</span>
          <span>Investor Relations</span>
          <span>Head of Product</span>
          <span>Legal &amp; Risk</span>
        </div>
      </div>

      <section className="problem">
        <div className="wrap">
          <div className="sec-head">
            <span className="eyebrow">Why Hey Sova</span>
            <h2>
              You're making C-suite decisions <em>without a C-suite.</em>
            </h2>
            <p className="lead">
              Pricing, fundraising, hiring, positioning — all of it lands on you, usually late at
              night, usually alone. Generic AI is agreeable and shallow. Advisors are expensive
              and slow to reach.
            </p>
          </div>
          <div className="pgrid">
            <div className="pcard">
              <div className="pnum">01</div>
              <h3>It's lonely at one</h3>
              <p>
                No team to pressure-test the call. You second-guess, or you don't — and both are
                dangerous.
              </p>
            </div>
            <div className="pcard">
              <div className="pnum">02</div>
              <h3>Generic AI just agrees</h3>
              <p>
                It doesn't know your numbers, your stage, or your cap table — so it flatters
                instead of challenging you.
              </p>
            </div>
            <div className="pcard">
              <div className="pnum">03</div>
              <h3>Advisors cost equity</h3>
              <p>
                A fractional exec or advisor wants cash or points you can't spare at the earliest,
                hardest stage.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WHY-IT-MATTERS — calm, in-house.ai style */}
      <section className="calm">
        <div className="wrap">
          <div className="sec-head">
            <span className="eyebrow">Why it matters</span>
            <h2>
              Most bad founder calls don't come from <em>bad data.</em>
            </h2>
            <p className="lead">They come from:</p>
          </div>
          <ul className="reasons" data-testid="reasons-list">
            <li>
              <span className="ix">01</span>
              <span>Making the call at 11pm, alone, with no one to push back.</span>
            </li>
            <li>
              <span className="ix">02</span>
              <span>One framing of the problem — never stress-tested from a different angle.</span>
            </li>
            <li>
              <span className="ix">03</span>
              <span>Sunk-cost momentum on a hypothesis no one will say is dead.</span>
            </li>
            <li>
              <span className="ix">04</span>
              <span>An AI that flatters you instead of asking the obvious harder question.</span>
            </li>
          </ul>
        </div>
      </section>

      <section id="cabinet">
        <div className="wrap">
          <div className="sec-head">
            <span className="eyebrow">Your executive</span>
            <h2>
              A leadership team that knows your business{" "}
              <em>by the second message.</em>
            </h2>
            <p className="lead">
              You tell Hey Sova about your company once. From then on, every advisor answers in
              context — with your stage, your model, and your constraints already in mind.
            </p>
          </div>
          <div className="roster">
            {[
              {
                who: "Strategy",
                role: "The Strategist",
                verb: "Pressure-tests your bet-the-company calls.",
              },
              {
                who: "Finance",
                role: "The CFO",
                verb: "Stress-tests your unit economics and burn.",
              },
              {
                who: "Marketing",
                role: "The CMO",
                verb: "Sharpens your positioning before launch.",
              },
              {
                who: "Growth",
                role: "Head of Growth",
                verb: "Designs the next experiment, not the next campaign.",
              },
              {
                who: "Operations",
                role: "Chief of Staff",
                verb: "Turns scattered to-dos into a sequenced week.",
              },
              {
                who: "Fundraising",
                role: "Investor Relations",
                verb: "Rehearses the questions VCs will actually ask.",
              },
              {
                who: "Product",
                role: "Head of Product",
                verb: "Cuts your roadmap down to what actually ships.",
              },
              {
                who: "Risk",
                role: "Legal & Risk",
                verb: "Flags the contract clauses you'd miss at 11pm.",
              },
            ].map(({ who, role, verb }) => (
              <div
                key={role}
                className="seat"
                data-testid={`seat-${role.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                <div className="who">{who}</div>
                <div className="role">{role}</div>
                <div className="verb">{verb}</div>
              </div>
            ))}
          </div>
          <p className="board-note">
            And when a decision touches money, ops, product and brand at once —{" "}
            <em>convene the boardroom,</em> and hear every advisor's take side by side.
          </p>
        </div>
      </section>

      {/* PHASE DIAGRAM — how a decision moves through the cabinet */}
      <section id="how" className="phase">
        <div className="wrap">
          <div className="sec-head">
            <span className="eyebrow">How it works</span>
            <h2>
              From a half-formed question to a sharp <em>second opinion</em> in minutes.
            </h2>
            <p className="lead">
              A decision moves through your executive the same way it would through a real
              leadership team — just faster, and at 11pm.
            </p>
          </div>
          <div className="phase-flow" data-testid="phase-flow">
            <div className="phase-step">
              <div className="pix">01 · Question</div>
              <div className="ptitle">Ask</div>
              <div className="psub">A messy thought, half a sentence, a paste from Slack.</div>
            </div>
            <div className="phase-step">
              <div className="pix">02 · Brief</div>
              <div className="ptitle">Context</div>
              <div className="psub">Your stage, model & constraints are already loaded.</div>
            </div>
            <div className="phase-step">
              <div className="pix">03 · 1:1</div>
              <div className="ptitle">Advisor</div>
              <div className="psub">Talk to one executive with a distinct point of view.</div>
            </div>
            <div className="phase-step">
              <div className="pix">04 · Group</div>
              <div className="ptitle">Boardroom</div>
              <div className="psub">Pose the same question to the whole team at once.</div>
            </div>
            <div className="phase-step">
              <div className="pix">05 · Synth</div>
              <div className="ptitle">Memo</div>
              <div className="psub">Eight takes collapsed into one decision memo.</div>
            </div>
            <div className="phase-step">
              <div className="pix">06 · Plan</div>
              <div className="ptitle">Milestones</div>
              <div className="psub">Action items lifted out of the memo, owners assigned.</div>
            </div>
            <div className="phase-step">
              <div className="pix">07 · Ship</div>
              <div className="ptitle">Sprint</div>
              <div className="psub">This-week milestones surface in the bell. You execute.</div>
            </div>
          </div>
          <p className="phase-foot">
            Saved conversations. Persistent context. The advice compounds — so the second
            decision is sharper than the first.
          </p>
        </div>
      </section>

      {/* DIVISION OF LABOR — what AI does vs. what you do */}
      <section className="division">
        <div className="wrap">
          <div className="sec-head">
            <span className="eyebrow">Division of labor</span>
            <h2>
              AI handles preparation. <em>You</em> handle judgment.
            </h2>
            <p className="lead">
              Hey Sova never takes the call for you. It does the prep so you can take it sharper.
            </p>
          </div>
          <div className="division-grid" data-testid="division-grid">
            <div className="division-col">
              <div className="colhead">AI handles</div>
              <div className="colbig">
                The thinking <em>around</em> the decision.
              </div>
              <ul>
                <li>Briefing every advisor on your company, once.</li>
                <li>Holding eight distinct points of view in parallel.</li>
                <li>Stress-testing the assumption you didn't say out loud.</li>
                <li>Collapsing the room into a one-page decision memo.</li>
                <li>Lifting milestones out of the memo into your plan.</li>
                <li>Surfacing the overdue ones in your bell on Monday.</li>
              </ul>
            </div>
            <div className="division-col">
              <div className="colhead">You handle</div>
              <div className="colbig">
                The <em>decision</em> itself.
              </div>
              <ul>
                <li>Picking which advisor to ask, when.</li>
                <li>Knowing when to convene the boardroom vs. ask one voice.</li>
                <li>Final judgment, ownership, and the company you're building.</li>
                <li>Choosing what to ship and what to kill.</li>
                <li>Doing the actual work.</li>
                <li>The 1:1 conversations Hey Sova can't replace.</li>
              </ul>
            </div>
          </div>
          <p className="division-foot">
            You own the call. Hey Sova just makes sure you've heard the room first.
          </p>
        </div>
      </section>

      <section className="offer">
        <div className="wrap">
          <div className="sec-head">
            <span className="eyebrow">Pricing</span>
            <h2>
              Pay once. Subscribe. Or <em>book the room.</em>
            </h2>
            <p className="lead">
              Three ways to use Hey Sova. All three are $80 anchored — because that's what one
              good night of clear thinking is worth.
            </p>
          </div>

          <div className="pricing-grid" data-testid="pricing-grid">
            {/* TIER 1 — Free trial */}
            <div className="ptier" data-testid="tier-trial">
              <span className="ptag">Try it</span>
              <div className="pname">Trial</div>
              <div className="ptag-line">24 hours. Full executive. No card.</div>
              <div className="pprice">
                <span className="now">$0</span>
                <span className="per">/ 24 hours</span>
              </div>
              <div className="plock">No credit card required</div>
              <ul>
                <li>Full access to all 15 advisors</li>
                <li>Convene the boardroom on any decision</li>
                <li>Auto-generated decision memos</li>
                <li>Saved conversations &amp; action plan</li>
              </ul>
              <button
                type="button"
                onClick={goToApp}
                className="pbtn pbtn-ghost"
                data-testid="tier-trial-cta"
              >
                Start free trial →
              </button>
            </div>

            {/* TIER 2 — Single decision (per-use) */}
            <div className="ptier popular" data-testid="tier-single">
              <span className="ptag">Most popular</span>
              <div className="pname">Single Decision</div>
              <div className="ptag-line">One call, one boardroom, one memo. Walk away.</div>
              <div className="pprice">
                <span className="now">$80</span>
                <span className="per">/ one-time</span>
              </div>
              <div className="plock">No subscription required</div>
              <ul>
                <li>One full boardroom session on a single decision</li>
                <li>All 15 advisors weigh in side by side</li>
                <li>One synthesized decision memo, yours to keep</li>
                <li>Milestones extracted into a 30-day action plan</li>
                <li>7 days to revisit the conversation</li>
              </ul>
              <button
                type="button"
                onClick={goToApp}
                className="pbtn pbtn-solid"
                data-testid="tier-single-cta"
              >
                Pay $80 — convene the room →
              </button>
            </div>

            {/* TIER 3 — Founding 50 subscription */}
            <div className="ptier" data-testid="tier-founding">
              <span className="ptag">Founding 50</span>
              <div className="pname">Subscription</div>
              <div className="ptag-line">Locked-for-life rate. Capped at 50 founders.</div>
              <div className="pprice">
                <span className="now">$80</span>
                <span className="per">/ month</span>
                <span className="was">$149</span>
              </div>
              <div className="plock">Founding rate — never goes up</div>
              <ul>
                <li>Unlimited boardrooms &amp; 1:1 advisor chats</li>
                <li>Every memo, plan and Monday briefing</li>
                <li>Saved conversations that compound over time</li>
                <li>Direct line to shape what gets built next</li>
                <li>Founding-member rate, forever</li>
              </ul>
              <button
                type="button"
                onClick={goToApp}
                className="pbtn pbtn-solid"
                data-testid="tier-founding-cta"
              >
                Reserve my seat →
              </button>
            </div>
          </div>

          {/* Executive Bench — live humans, price on request */}
          <div className="exec-strip" data-testid="exec-bench">
            <div>
              <div className="estag">Executive Bench</div>
              <h3>
                When you need <em>a real human</em> in the room.
              </h3>
              <p>
                Schedule a live executive team session, or a 1:1 with a specific board-level
                advisor. Vetted executives across CFO, CMO, growth, fundraising, legal and ops.
                Pricing on request — depends on the executive, the scope, and your stage.
              </p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <a
                href="mailto:info@heysova.io?subject=Executive%20Bench%20%E2%80%94%20live%20advisor%20request"
                className="pbtn pbtn-solid"
                data-testid="exec-bench-cta"
                style={{ background: "var(--fg)", color: "var(--bg)" }}
              >
                Request availability →
              </a>
              <a
                href="/apply-to-bench"
                className="pbtn pbtn-ghost"
                data-testid="apply-bench-cta"
                style={{ background: "var(--bg)", color: "var(--fg)" }}
              >
                I'm an executive — apply →
              </a>
            </div>
          </div>

          {/* Approved experts grid (only shows once any are approved) */}
          {experts.length > 0 && (
            <div className="bench-grid" data-testid="bench-grid">
              {experts.map((ex) => (
                <div key={ex.id} className="bench-card" data-testid={`bench-card-${ex.id}`}>
                  <div className="bench-name">{ex.name}</div>
                  <div className="bench-role">{ex.role}</div>
                  <p className="bench-bio">{ex.bio}</p>
                  {ex.expertise && ex.expertise.length > 0 && (
                    <div className="bench-tags">
                      {ex.expertise.map((t) => (
                        <span key={t} className="bench-tag">{t}</span>
                      ))}
                    </div>
                  )}
                  <div className="bench-meta">
                    {ex.session_price_usd
                      ? `Session $${ex.session_price_usd}`
                      : ex.hourly_rate_usd
                      ? `From $${ex.hourly_rate_usd}/hr`
                      : "Rate on request"}
                  </div>
                  {ex.session_price_usd ? (
                    <button
                      onClick={() => startBenchBooking(ex)}
                      className="bench-cta"
                      data-testid={`book-${ex.id}`}
                      disabled={bookingBusy === ex.id}
                    >
                      {bookingBusy === ex.id
                        ? "Opening checkout…"
                        : `Pay $${ex.session_price_usd} & Book →`}
                    </button>
                  ) : ex.cal_link ? (
                    <a
                      href={ex.cal_link}
                      target="_blank"
                      rel="noreferrer"
                      className="bench-cta"
                      data-testid={`book-${ex.id}`}
                    >
                      Book on Cal.com →
                    </a>
                  ) : (
                    <a
                      href={`mailto:info@heysova.io?subject=Book%20${encodeURIComponent(ex.name)}%20%E2%80%94%20Executive%20Bench&body=Hi%20Hey%20Sova%2C%0A%0AI%27d%20like%20to%20request%20a%20session%20with%20${encodeURIComponent(ex.name)}.%20Here%27s%20what%20I%27m%20looking%20to%20discuss%3A%0A%0A%5BYour%20message%5D%0A%0AThanks%21`}
                      className="bench-cta"
                      data-testid={`book-${ex.id}`}
                    >
                      Request to book →
                    </a>
                  )}
                  <div style={{
                    fontSize: 10, fontWeight: 700, letterSpacing: "0.08em",
                    textTransform: "uppercase", color: "rgba(0,0,0,0.5)", marginTop: 10, lineHeight: 1.5,
                  }}>
                    Pay now · pick a time next · refund only if no-show
                  </div>
                </div>
              ))}
            </div>
          )}

          <p className="pricing-foot">
            Pay only for what you use. Cancel any subscription any time.
          </p>
        </div>
      </section>

      {/* WHY FOUNDERS CHOOSE HEY SOVA — stats */}
      <section className="why-choose">
        <div className="wrap">
          <div className="sec-head">
            <span className="eyebrow">Why founders choose Hey Sova</span>
            <h2>
              Built for the calls you make when there's <em>no one to ask.</em>
            </h2>
            <p className="lead">
              The math that makes Hey Sova obvious vs. hiring a fractional bench or asking
              generic AI.
            </p>
          </div>
          <div className="stats-grid" data-testid="stats-grid">
            <div className="stat" data-testid="stat-save">
              <div className="sicon" />
              <div className="snum">$240K+</div>
              <div className="ssub">Saved vs. fractional execs</div>
              <div className="stitle">Executive, not contracts</div>
              <div className="sdesc">
                A fractional CFO + CMO + COO bench runs $20K/mo and up. Hey Sova is $80/mo for
                all 15 — no SAFEs, no equity, no comp packages.
              </div>
            </div>
            <div className="stat" data-testid="stat-speed">
              <div className="sicon" />
              <div className="snum">24/7</div>
              <div className="ssub">Sharp opinion, 11pm or 6am</div>
              <div className="stitle">Time-shift your bench</div>
              <div className="sdesc">
                Real advisors return calls in weeks. Hey Sova answers the moment the question
                lands — and remembers the thread next time you open the room.
              </div>
            </div>
            <div className="stat" data-testid="stat-voices">
              <div className="sicon" />
              <div className="snum">15 voices</div>
              <div className="ssub">One boardroom, one memo</div>
              <div className="stitle">Stress-tested by default</div>
              <div className="sdesc">
                Every cross-functional decision touches finance, ops, product, and brand at once.
                Hey Sova hears the whole room and collapses 15 takes into a one-page memo.
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="founder">
        <div className="wrap founder-inner">
          <span className="eyebrow founder-eyebrow">From the founder</span>
          <blockquote>
            "I've negotiated multi-million-dollar contracts for Fortune 500s — and I still found
            myself making the biggest calls of my own company{" "}
            <em>completely alone, at 11pm.</em> Hey Sova is the advisory bench I wished I'd had. I
            built it for the founder I was."
          </blockquote>
          <div className="sig">
            <strong>Teresa Waicekauskas</strong> · Founder, Hey Sova
          </div>
        </div>
      </section>

      {/* FEEDBACK FORM */}
      <section className="feedback" data-testid="feedback-section">
        <div className="wrap">
          <div className="sec-head">
            <span className="eyebrow">Questions or comments</span>
            <h2>
              We read every note. <em>Quickly.</em>
            </h2>
            <p className="lead">
              Use this to flag bugs, request a feature, ask about the founding rate, or just tell
              us what's working. It lands in <a href="mailto:info@heysova.io" style={{ color: "var(--bg)", textDecoration: "underline", textUnderlineOffset: 3 }}>info@heysova.io</a> within the hour.
            </p>
          </div>

          <div className="feedback-grid">
            <form className="feedback-form" onSubmit={submitFeedback} data-testid="feedback-form">
              <div className="feedback-row">
                <div>
                  <label htmlFor="fb-name">Name (optional)</label>
                  <input
                    id="fb-name"
                    type="text"
                    value={fbName}
                    onChange={(e) => setFbName(e.target.value)}
                    placeholder="Who's writing?"
                    data-testid="feedback-name"
                    maxLength={200}
                  />
                </div>
                <div>
                  <label htmlFor="fb-email">Email (if you want a reply)</label>
                  <input
                    id="fb-email"
                    type="email"
                    value={fbEmail}
                    onChange={(e) => setFbEmail(e.target.value)}
                    placeholder="you@yourcompany.com"
                    data-testid="feedback-email"
                    maxLength={200}
                  />
                </div>
              </div>
              <div>
                <label htmlFor="fb-msg">Your message</label>
                <textarea
                  id="fb-msg"
                  value={fbMsg}
                  onChange={(e) => setFbMsg(e.target.value)}
                  placeholder="Tell us what you're thinking — feedback, a bug, a feature, a question."
                  data-testid="feedback-message"
                  maxLength={5000}
                  required
                />
              </div>
              <button
                type="submit"
                className="feedback-submit"
                disabled={fbBusy}
                data-testid="feedback-submit"
              >
                {fbBusy ? "Sending…" : "Send to Hey Sova →"}
              </button>
              {fbStatus && (
                <div
                  className={`feedback-status ${fbStatus.kind === "ok" ? "ok" : "err"}`}
                  data-testid="feedback-status"
                  role="status"
                >
                  {fbStatus.text}
                </div>
              )}
            </form>

            <aside className="feedback-side">
              <div className="ssbig">
                Or just <em>email us.</em>
              </div>
              <p>
                We respond like humans, not like a ticket queue. If your message is sensitive or
                long, an email is fine too.
              </p>
              <a
                href="mailto:info@heysova.io?subject=Hey%20Sova%20%E2%80%94%20message"
                className="mailto-btn"
                data-testid="feedback-mailto"
              >
                Email info@heysova.io →
              </a>
              <div className="addr">
                Replies usually inside one business day · <a href="mailto:info@heysova.io">info@heysova.io</a>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <section className="faq">
        <div className="wrap">
          <div className="sec-head">
            <span className="eyebrow">Questions</span>
            <h2>Before you reserve.</h2>
          </div>
          <details data-testid="faq-item-1">
            <summary>Is this just ChatGPT with a costume on?</summary>
            <p>
              No. Generic assistants start cold every time and tend to agree with you. Hey Sova's
              advisors are grounded in your company from the first message, hold distinct points
              of view, and are built to challenge weak assumptions — not flatter them.
            </p>
          </details>
          <details data-testid="faq-item-2">
            <summary>How does the founding rate work?</summary>
            <p>
              The first 50 founders lock in $80/month for life — even after the public rate rises.
              You're billed monthly from the day you subscribe, and you can cancel anytime from
              your account. Your founding-member rate stays with your seat as long as you stay
              subscribed.
            </p>
          </details>
          <details data-testid="faq-item-3">
            <summary>When does it launch?</summary>
            <p>
              The founding cohort shapes the build. Founding members get first access as features
              roll out, plus a direct line to request what gets built next.
            </p>
          </details>
          <details data-testid="faq-item-4">
            <summary>Who is it for?</summary>
            <p>
              Founders building venture-scale companies who are making
              executive decisions without an executive team — and want a sharper, faster second
              opinion than they can get anywhere else.
            </p>
          </details>
          <details data-testid="faq-item-5">
            <summary>Can it replace my advisors or lawyer?</summary>
            <p>
              No — and it won't pretend to. Hey Sova is for thinking faster and sharper between
              those conversations. For binding legal, tax, or financial decisions, it points you
              to a licensed professional.
            </p>
          </details>
        </div>
      </section>

      <section className="final">
        <div className="wrap">
          <h2>
            Stop deciding <em>alone.</em>
          </h2>
          <p className="sub">
            Fifty founding seats. Locked at $80 forever. An executive in your pocket.
          </p>
          <div className="cta-row">
            <button
              type="button"
              onClick={goToApp}
              className="btn btn-primary"
              data-testid="final-reserve-btn"
            >
              Reserve your seat →
            </button>
          </div>
        </div>
      </section>

      <footer>
        <div className="wrap">
          <div className="foot-inner">
            <div className="logo">HEY SOVA</div>
            <div>© 2026 Hey Sova</div>
          </div>
          <p className="disclaimer">
            Hey Sova provides AI-generated guidance for informational purposes only and is not a
            substitute for professional legal, financial, tax, or business advice.
          </p>
        </div>
      </footer>
    </div>
  );
}
